import { relations } from "drizzle-orm"
import {
  pgTable,
  serial,
  timestamp,
  boolean,
  varchar,
} from "drizzle-orm/pg-core"
import { eventsEmailsTable } from "./EventsEmails"

export const eventsTable = pgTable("Events", {
  id: serial().primaryKey(),
  title: varchar().notNull(),
  startTimestamp: timestamp({ withTimezone: true }).notNull(),
  endTimestamp: timestamp({ withTimezone: true }).notNull(),
  subscriptionEndTimestamp: timestamp({ withTimezone: true }),
  disabled: boolean().notNull().default(false),
  description: varchar().notNull().default(""),
  location: varchar().notNull().default(""),
})

export const eventsTableRelations = relations(
  eventsTable,
  ({ many }) => ({
    emails: many(eventsEmailsTable)
  }),
)

export type EventSchema = typeof eventsTable.$inferSelect
export type NewEventSchema = typeof eventsTable.$inferInsert
